import CategoryAnswer from "../models/answer/categoryAnswer.model";
import {GenericConstants} from "../constants/generic.constants";
import {toast} from "react-toastify";
import React from "react";
import Category from "../models/category/category.model";
import exp from "node:constants";
import {CategoryHelper} from "./category.helper";

class CategoryAnswerHelper {
    static validateNoDuplicateAnswers = (categories: Category[], categoryAnswers: CategoryAnswer[]): CategoryAnswer[] => {
        const groupedByParentCategory = [...categoryAnswers].reduce<Record<string, CategoryAnswer[]>>((acc, item) => {
            if (!item) {
                return acc;
            }

            const parentAndChildCategory = CategoryHelper.getChildWithParentCategoryFromChildCategoryId(item.categoryId, categories);

            if (!parentAndChildCategory) {
                return acc;
            }

            // Check validation for duplicate responses only if they exist in the defined list
            // e.g allow duplicated in Star Signs but not Love Language
            if(!Object.keys(GenericConstants.PreventDuplicateAnswerCategories).find(gc => gc == parentAndChildCategory.parent!.title))
            {
                return acc;
            }

            //todo different solution around category type see https://trello.com/c/41fPjLmF/141-change-category-and-quiz
            item.categoryTitle = parentAndChildCategory.child.title;

            if (!acc[parentAndChildCategory.parent.title]) {
                acc[parentAndChildCategory.parent.title] = [];
            }

            acc[parentAndChildCategory.parent.title].push(item);

            return acc;
        }, {});

        const duplicatesByParentCategory: CategoryAnswer[] = [];
        if (Object.keys(groupedByParentCategory).length == 0) {
            return duplicatesByParentCategory;
        }

        for (const [parentCategory, groupedItems] of Object.entries(groupedByParentCategory)) {
            const duplicatePreventedFields = GenericConstants.PreventDuplicateAnswerCategories[parentCategory];

            // Use a map to count occurrences of each label
            const labelCount = groupedItems.reduce<Record<string, number>>((acc, item) => {
                // Only count the labels that are on the fields we want to track
                if (!duplicatePreventedFields.includes(item.categoryTitle ?? "")) {
                    return acc;
                }

                acc[item.label] = (acc[item.label] || 0) + 1;
                return acc;
            }, {});

            // Filter out items that have more than one occurrence (duplicates)
            const duplicates = groupedItems.filter(item => {
                // Only count the category answers on fields we want to track
                if (!duplicatePreventedFields.includes(item.categoryTitle ?? "")) {
                    return false;
                }
                return labelCount[item.label] > 1
            });

            if (duplicates.length > 0) {
                duplicatesByParentCategory.push(...duplicates);
            }
        }

        return duplicatesByParentCategory;
    };
}

export {CategoryAnswerHelper}